import * as React from 'react'
import { FilterClass } from '@sphinx/components-styles'
import * as classNames from 'classnames'
import { SearchIcon as SearchImg } from '../icons'

export const FilterTitle: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  title,
  ...props
}) => (
  <span className={classNames(FilterClass.title, className)} {...props}>
    {title}
  </span>
)

export const Filter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => (
  <div className={classNames(FilterClass.wrap, className)} {...props}>
    {children}
  </div>
)

interface FilterActionsSectionProps
  extends React.HTMLAttributes<HTMLDivElement> {
  label?: string
}

export const FilterActions: React.FC<FilterActionsSectionProps> = ({
  children,
  className,
  label,
  ...props
}) => (
  <div className={classNames(FilterClass.section, className)} {...props}>
    <p className={FilterClass.label}>{label}</p>
    {children}
  </div>
)

interface FilterActionProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  ref?: React.Ref<HTMLInputElement>
  placeholder?: string
}

export const FilterActionSearch: React.FC<FilterActionProps> = ({
  className,
  placeholder,
  ...props
}) => (
  <div className={classNames(FilterClass.searchBox, className)}>
    <input
      className={FilterClass.searchInput}
      placeholder={placeholder}
      {...props}
    />
    <SearchImg className={FilterClass.searchIcon} />
  </div>
)
